import React from 'react';
// contexts
import TicketsProvider from '../../contexts/Tickets';
// components
import Page from '../../components/Page';
import SectionList from '../../components/section/list';

export default function PageSectionList() {
  return (
    <Page title="Ticket" path="/ticket/list">
      <TicketsProvider>
        <SectionList />
      </TicketsProvider>
    </Page>
  );
}
